import { render } from "./input_email_and_tel.vue?vue&type=template&id=0aac4462&scoped=true"
import script from "./input_email_and_tel.vue?vue&type=script&lang=js"
export * from "./input_email_and_tel.vue?vue&type=script&lang=js"

import "./input_email_and_tel.vue?vue&type=style&index=0&id=0aac4462&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aac4462"]])

export default __exports__